import { WithChildren } from '_metronic/helpers'

import ModalContextProvider from './Modal/context'
import { TableContextProvider } from './Table'
import { PromptContextProvider } from './Prompt'
import { LocationSelectionMapContextProvider } from './LocationSelectionModal'

const AppContext: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <ModalContextProvider>
        <TableContextProvider>
          <PromptContextProvider>
            <LocationSelectionMapContextProvider>{children}</LocationSelectionMapContextProvider>
          </PromptContextProvider>
        </TableContextProvider>
      </ModalContextProvider>
    </>
  )
}

export default AppContext
